'use client';

import PDP from 'components/consumer/PDP';
import AdminPlaceholder from 'components/consumer/AdminPlaceholder';

const PDPClient = ({
  productOptionsPromise,
  productHeroImagePromise,
  productCylindoHeroImagePromise,
  productBasicDetailsPromise,
  productIdentityPromise,
  layoutRevampContextPromise,
  slug,
  warehouseIdPromise,
  isAdmin,
}) => {
  if (isAdmin) {
    return (
      <AdminPlaceholder>
        ProductAndCategory Component Placeholder for Variant Builder. <br />
        The component will display the product page correctly in Consumer
      </AdminPlaceholder>
    );
  }

  return (
    <PDP
      key={slug}
      productOptionsPromise={productOptionsPromise}
      productHeroImagePromise={productHeroImagePromise}
      productCylindoHeroImagePromise={productCylindoHeroImagePromise}
      productBasicDetailsPromise={productBasicDetailsPromise}
      productIdentityPromise={productIdentityPromise}
      layoutRevampContextPromise={layoutRevampContextPromise}
      warehouseIdPromise={warehouseIdPromise}
    />
  );
};

export default PDPClient;
